import React from "react";
import { Container, Typography } from "@mui/material";

const AboutUs = () => (
  <Container sx={{ mt: 4 }}>
    <Typography variant="h4" gutterBottom>About HPHT Technology</Typography>

    <Typography variant="body1" paragraph>
      HPHT Technology is a forward-thinking engineering company that designs and
      builds innovative vending solutions tailored for smart environments. We combine
      hardware, IoT, and digital payment technologies to deliver seamless self-service
      retail experiences.
    </Typography>

    <Typography variant="body1" paragraph>
      Our vending systems serve offices, campuses, industrial zones, and public areas
      with 24/7 convenience. We specialize in fully automated vending machines,
      cloud-based inventory control, and secure QR-based product retrieval.
    </Typography>

    <Typography variant="body1" paragraph>
      At HPHT, we’re committed to quality, transparency, and customer satisfaction
      while advancing Malaysia’s smart vending ecosystem.
    </Typography>
  </Container>
);

export default AboutUs;